(function () {
  'use strict';

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ß/g, 'ss')
      .replace(/%20/g, ' ')
      .replace(/[-_+.]+/g, ' ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function decodeSafe(value) {
    try { return decodeURIComponent(String(value || '')); }
    catch (e) { return String(value || ''); }
  }

  var COLOR_ALIASES = [
    { family: 'white', keys: ['white', 'blanco', 'blanca', 'weiss', 'weiss', 'bianco', 'branco', 'blanc', 'perla', 'pearl'] },
    { family: 'black', keys: ['black', 'negro', 'negra', 'schwarz', 'noir', 'nero', 'preto', 'graphite', 'grafito', 'anthracite', 'antracita'] },
    { family: 'grey', keys: ['grey', 'gray', 'gris', 'grau', 'silver', 'plata', 'silber'] },
    { family: 'brown', keys: ['brown', 'marron', 'marron', 'braun', 'copper', 'cobre', 'chocolate', 'bronze', 'bronce', 'beige', 'sand', 'arena', 'cream', 'crema'] },
    { family: 'blue', keys: ['blue', 'azul', 'blau', 'blu', 'bleu', 'navy', 'marine', 'bluegreen', 'blue green', 'sky', 'cyan'] },
    { family: 'green', keys: ['green', 'verde', 'grun', 'gruen', 'olive', 'oliva', 'poolgreen', 'pool green', 'mint'] },
    { family: 'red', keys: ['red', 'rojo', 'roja', 'rot', 'rouge', 'rosso', 'vermelho'] },
    { family: 'orange', keys: ['orange', 'naranja', 'mandarina'] },
    { family: 'yellow', keys: ['yellow', 'amarillo', 'amarilla', 'gelb', 'gold', 'dorado', 'oro'] },
    { family: 'purple', keys: ['purple', 'violeta', 'morado', 'morada', 'purpura', 'lila'] },
    { family: 'pink', keys: ['pink', 'rosa'] }
  ];

  function selectedColorAliases(value) {
    var n = normalize(value);
    var result = [];
    if (n) result.push(n);

    COLOR_ALIASES.forEach(function (entry) {
      var hit = entry.keys.some(function (key) {
        return n === normalize(key) || n.indexOf(normalize(key)) !== -1 || normalize(key).indexOf(n) !== -1;
      });
      if (hit) {
        entry.keys.forEach(function (key) { result.push(normalize(key)); });
      }
    });

    // Avoid matching very weak generic tokens.
    return Array.from(new Set(result.filter(function (token) {
      return token && token.length >= 3 && ['glossy', 'matt', 'matte', 'bike', 'ebike', 'ebikes', 'color', 'farbe'].indexOf(token) === -1;
    })));
  }

  function getRootList(root) {
    if (root && root.matches && root.matches('[id^="lbx-product-"]')) return [root];
    return Array.prototype.slice.call((root || document).querySelectorAll('[id^="lbx-product-"]'));
  }

  function findColorBlock(root) {
    return root.querySelector('.lbx-option-block[data-lbx-v30-role="color"], .lbx-option-block[data-lbx-v29-role="color"], .lbx-option-block:has(.lbx-color-list)') ||
      Array.prototype.slice.call(root.querySelectorAll('.lbx-option-block')).find(function (block) {
        var text = normalize(block.querySelector('.lbx-option-label') ? block.querySelector('.lbx-option-label').textContent : '');
        return text.indexOf('color') !== -1 || text.indexOf('farbe') !== -1 || text.indexOf('colour') !== -1 || text.indexOf('couleur') !== -1;
      });
  }

  function getSelectedColor(root) {
    var block = findColorBlock(root);
    if (!block) return '';
    var active = block.querySelector('[data-lbx-option-button].is-active') || block.querySelector('.is-active');
    var value = active && (active.getAttribute('data-lbx-option-value') || active.getAttribute('title') || active.getAttribute('aria-label'));
    if (value) return value;
    var current = block.querySelector('[data-lbx-current-option]');
    return current ? current.textContent : '';
  }

  function itemHaystack(button) {
    var image = button.querySelector('img');
    return normalize([
      button.getAttribute('data-image-alt'),
      button.getAttribute('data-image-src'),
      button.getAttribute('data-image-src-mobile'),
      button.getAttribute('data-image-src-desktop'),
      image && image.getAttribute('alt'),
      image && image.getAttribute('src')
    ].map(decodeSafe).join(' '));
  }

  function buttonSrc(button) {
    var vw = (window.visualViewport && window.visualViewport.width) || window.innerWidth || document.documentElement.clientWidth || 9999;
    return (vw <= 700 ? (button.getAttribute('data-image-src-mobile') || button.getAttribute('data-image-src')) : (button.getAttribute('data-image-src-desktop') || button.getAttribute('data-image-src'))) || '';
  }

  function setMainImage(root, button) {
    var src = buttonSrc(button);
    if (!src) return;
    var main = root.querySelector('[data-lbx-main-image]');
    if (!main) return;
    var alt = button.getAttribute('data-image-alt') || (button.querySelector('img') && button.querySelector('img').alt) || '';
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.src = src;
    main.alt = alt;
    var wrap = main.closest('[data-lbx-main-image-wrap]');
    if (wrap) {
      wrap.style.setProperty('background-image', 'url("' + String(src).replace(/"/g, '%22') + '")', 'important');
      wrap.style.setProperty('background-repeat', 'no-repeat', 'important');
      wrap.style.setProperty('background-position', 'center', 'important');
      wrap.style.setProperty('background-size', 'contain', 'important');
      wrap.classList.add('is-image-loaded');
    }
  }

  function visibleButtons(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-lbx-thumbnail]')).filter(function (button) {
      return button.getAttribute('data-lbx-v31-hidden') !== 'true';
    });
  }

  function keepThumbnailVisible(button) {
    if (!button) return;
    var scroller = button.closest('.lbx-thumbnails, [data-lbx-thumbnails]');
    if (!scroller) return;

    var targetLeft = button.offsetLeft - (scroller.clientWidth / 2) + (button.clientWidth / 2);
    var nextLeft = Math.max(0, targetLeft);

    if (typeof scroller.scrollTo === 'function') {
      scroller.scrollTo({ left: nextLeft, behavior: 'smooth' });
    } else {
      scroller.scrollLeft = nextLeft;
    }
  }

  function setActive(root, button) {
    root.querySelectorAll('[data-lbx-thumbnail]').forEach(function (thumb) { thumb.classList.toggle('is-active', thumb === button); });
    setMainImage(root, button);
    // Scroll only the horizontal thumbnail rail. scrollIntoView also moves the page
    // vertically and was the cause of the automatic jump on load/variant changes.
    keepThumbnailVisible(button);
  }

  function applyFilter(root) {
    var selected = getSelectedColor(root);
    var aliases = selectedColorAliases(selected);
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-lbx-thumbnail]'));
    if (!thumbs.length || !aliases.length) return;

    var matched = thumbs.filter(function (button) {
      var haystack = itemHaystack(button);
      return aliases.some(function (alias) { return haystack.indexOf(alias) !== -1; });
    });

    // Safety: if product media is not labelled/assigned with colour data, keep all media visible.
    if (!matched.length) {
      thumbs.forEach(function (button) {
        button.hidden = false;
        button.style.display = '';
        button.removeAttribute('data-lbx-v31-hidden');
      });
      root.removeAttribute('data-lbx-v31-media-filter-active');
      return;
    }

    root.setAttribute('data-lbx-v31-media-filter-active', 'true');
    thumbs.forEach(function (button) {
      var show = matched.indexOf(button) !== -1;
      button.hidden = !show;
      button.style.display = show ? '' : 'none';
      if (show) button.removeAttribute('data-lbx-v31-hidden');
      else button.setAttribute('data-lbx-v31-hidden', 'true');
      if (!show) button.classList.remove('is-active');
    });

    var active = matched.find(function (button) { return button.classList.contains('is-active'); }) || matched[0];
    if (active) setActive(root, active);
  }

  function move(root, direction) {
    if (root.getAttribute('data-lbx-v31-media-filter-active') !== 'true') return false;
    var buttons = visibleButtons(root);
    if (!buttons.length) return false;
    var current = buttons.findIndex(function (button) { return button.classList.contains('is-active'); });
    if (current < 0) current = 0;
    var next = current + direction;
    if (next < 0) next = buttons.length - 1;
    if (next >= buttons.length) next = 0;
    setActive(root, buttons[next]);
    return true;
  }

  function bindRoot(root) {
    if (!root || root.getAttribute('data-lbx-v31-bound') === 'true') return;

    // Los accesorios no tienen variantes de color de bici. Evita que este filtro
    // oculte miniaturas o cambie la imagen principal tras la carga.
    if (root.getAttribute('data-lbx-product-kind') === 'accessory' || root.classList.contains('is-accessory-product')) {
      return;
    }

    root.setAttribute('data-lbx-v31-bound', 'true');

    root.addEventListener('click', function (event) {
      var optionButton = event.target.closest && event.target.closest('[data-lbx-option-button]');
      if (optionButton) {
        window.setTimeout(function () { applyFilter(root); }, 80);
        window.setTimeout(function () { applyFilter(root); }, 280);
        return;
      }

      var next = event.target.closest && event.target.closest('[data-lbx-gallery-next]');
      var prev = event.target.closest && event.target.closest('[data-lbx-gallery-prev]');
      if (next || prev) {
        if (move(root, next ? 1 : -1)) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
        }
      }
    }, true);

    root.addEventListener('click', function (event) {
      var thumb = event.target.closest && event.target.closest('[data-lbx-thumbnail]');
      if (thumb && thumb.getAttribute('data-lbx-v31-hidden') !== 'true') {
        window.setTimeout(function () { setActive(root, thumb); }, 0);
      }
    }, true);

    [80, 350, 900, 1600].forEach(function (delay) {
      window.setTimeout(function () { applyFilter(root); }, delay);
    });
  }

  function boot(root) {
    getRootList(root || document).forEach(bindRoot);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      Array.prototype.slice.call(mutation.addedNodes || []).forEach(function (node) {
        if (node.nodeType === 1) boot(node);
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
